<template>
    <div class="row" v-if="isValid('CanAddSaleReturn')" v-bind:style="$i18n.locale == 'ar' ? languageChange('en') : languageChange('ar')">
        <div class="col-md-12 ml-auto mr-auto mt-3">
            <div class="card" v-if="isDayAlreadyStart">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="card-header ">
                            <div class="row" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 poHeading" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                    <span>{{ $t('AddSaleReturn.ServiceSaleReturn') }} <span style="font-weight:bold"> - {{sale.registrationNo}}</span></span>

                                </div>
                                <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 poHeading" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                    <span style="font-weight:bold">{{sale.isCredit ? 'Credit':'Cash'}} </span>

                                </div>

                                <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 dateHeading" v-bind:class="$i18n.locale == 'en' ? 'text-right' : 'text-left'">

                                    <span>
                                        {{sale.date}}
                                    </span>
                                </div>
                            </div>
                            <div class="row bottomBorder">

                            </div>
                        </div>


                        <div class="card-body  ">
                            <div class="row">
                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                    <sale-invoice-dropdown v-model="sale.saleInvoiceId" @input="getSaleDetail" :IsService="true" />
                                </div>
                            </div>
                            <div class="row">

                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-if="!sale.isCredit" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                    <label>{{ $t('AddSaleReturn.Customer') }} :<span class="LabelColour"> *</span></label>
                                    <div v-bind:class="{'has-danger': $v.sale.cashCustomer.$error}">
                                        <input type="text" class="form-control" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'"
                                               disabled
                                               @focus="$event.target.select()"
                                               v-model="$v.sale.cashCustomer.$model" />
                                        <span v-if="$v.sale.cashCustomer.$error"
                                              class="error text-danger">
                                        </span>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-if="!sale.isCredit" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                    <label>{{ $t('AddSaleReturn.Mobile') }} :</label>
                                    <div v-bind:class="{'has-danger': $v.sale.mobile.$error}">
                                        <input type="text" class="form-control" v-model="$v.sale.mobile.$model" disabled v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'" />
                                        <span v-if="$v.sale.mobile.$error"
                                              class="error text-danger">
                                        </span>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                    <label>{{ $t('AddSaleReturn.Customer') }} :<span class="LabelColour"> *</span></label>
                                    <div v-bind:class="{'has-danger': $v.sale.customerId.$error}">
                                        <customerdropdown v-model="$v.sale.customerId.$model" :disable="true" v-bind:values="sale.customerId" v-bind:key="rendered" />

                                        <span v-if="$v.sale.customerId.$error"
                                              class="error text-danger">
                                        </span>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-if="sale.isCredit" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                    <label>{{ $t('AddSaleReturn.DueDate') }} :</label>
                                    <div v-bind:class="{'has-danger': $v.sale.dueDate.$error}">
                                        <datepicker v-model="$v.sale.dueDate.$model" disabled />

                                        <span v-if="$v.sale.dueDate.$error"
                                              class="error text-danger">
                                        </span>
                                    </div>
                                </div>

                                <div :class="{'col-xs-12 col-sm-6 col-md-6 col-lg-6':sale.isCredit, 'col-xs-12 col-sm-6 col-md-3 col-lg-3': !sale.isCredit}">
                                    <label style="width:100%;" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">{{ $t('AddSaleReturn.WareHouse') }} :<span class="LabelColour"> *</span></label>
                                    <div>
                                        <warehouse-dropdown v-model="$v.sale.wareHouseId.$model" :disable="true" />
                                        <span v-if="$v.sale.dueDate.$error"
                                              class="error text-danger">
                                        </span>
                                    </div>
                                </div>

                                <div v-if="saleDefaultVat=='DefaultVatHead' || saleDefaultVat=='DefaultVatHeadItem'" class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-bind:class=" $i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                    <label>{{ $t('AddPurchase.TaxMethod') }} :<span class="LabelColour"> *</span></label>
                                    <multiselect v-if="this.$i18n.locale == 'en'" :options="['Inclusive', 'Exclusive']" v-bind:disabled="sale.saleItems.length>0" v-model="sale.taxMethod" :show-labels="false" v-bind:placeholder="$t('AddStockValue.SelectMethod')" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                    </multiselect>
                                    <multiselect v-else :options="['شامل', 'غير شامل']" v-bind:disabled="sale.saleItems.length>0" v-model="sale.taxMethod" :show-labels="false" v-bind:placeholder="$t('AddStockValue.SelectMethod')" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                    </multiselect>
                                </div>
                                <div v-if="saleDefaultVat=='DefaultVatHead' || saleDefaultVat=='DefaultVatHeadItem'" class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                    <label>{{ $t('AddPurchase.VAT%') }} :<span class="LabelColour"> *</span></label>
                                    <taxratedropdown v-model="sale.taxRateId" v-bind:value="sale.taxRateId" :isDisable="sale.saleItems.length>0? true :false" v-bind:key="rendered" />
                                </div>
                            </div>
                            <br />
                            <!--<sale-return-item :saleItems="sale.saleItems" @input="SaveSaleItems" @summary="updateSummary" :key="rendered" />-->
                            <sale-service-item :saleItems="sale.saleItems" @input="SaveSaleItems" @summary="updateSummary" :key="rendered" :formName="'saleReturn'" />
                            <div class="row">
                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                    <label>{{ $t('AddSale.TermAndConditionEnglish') }}:</label>
                                    <VueEditor v-model="sale.termAndCondition" />
                                </div>
                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                    <label>{{ $t('AddSale.TermAndConditionArabic') }}:</label>
                                    <VueEditor v-model="sale.termAndConditionAr" />
                                </div>
                            </div>
                            <div v-if="!loading" class="col-md-12 arabicLanguage" v-bind:style="$i18n.locale == 'en' ? '' : 'direction: rtl'">
                                <button class="btn btn-primary mr-2 float-left" v-on:click="Attachment()">
                                    {{ $t('AddSale.Attachment') }}
                                </button>

                                <div v-if="sale.id === '00000000-0000-0000-0000-000000000000'">
                                    <!--<button class="btn btn-primary  mr-2"
                                        v-on:click="saveSaleReturn('SaleReturn',false,false)"
                                        v-if="isValid('Can Save Sale Return') && isValid('Can Edit  Sale Return')"
                                        :disabled="$v.$invalid || sale.saleItems.filter(x => x.outOfStock).length > 0 || sale.saleItems.filter(x => x.quantity=='').length > 0 || sale.saleItems.filter(x => x.unitPrice=='').length > 0">
                                    <i class="far fa-save"></i>  {{ $t('PurchaseOrder.SaveAsDraft') }}
                                </button>-->
                                    <button class="btn btn-primary  mr-2"
                                            v-on:click="saveSaleReturn('SaleReturn',true,false)"
                                            v-if="isValid('CanAddSaleReturn')"
                                            :disabled="$v.$invalid || sale.saleItems.filter(x => x.outOfStock).length > 0 || sale.saleItems.filter(x => x.totalPiece=='').length > 0 || sale.saleItems.filter(x => x.unitPrice=='').length > 0">
                                        <i class="far fa-save"></i>  {{ $t('AddSaleReturn.SaveAsPost') }}
                                    </button>
                                    <button class="btn btn-primary  mr-2"
                                            v-on:click="saveSaleReturn('SaleReturn',true,true)"
                                            v-if="isValid('CanAddSaleReturn') && isValid('CanPrintInvoice')"
                                            :disabled="$v.$invalid || sale.saleItems.filter(x => x.outOfStock).length > 0 || sale.saleItems.filter(x => x.totalPiece=='').length > 0 || sale.saleItems.filter(x => x.unitPrice=='').length > 0">
                                        <i class="far fa-save"></i>  {{ $t('AddSaleReturn.SaveasPostandPrint') }}
                                    </button>
                                    <button class="btn btn-danger  mr-2"
                                            v-on:click="goToSale">
                                        {{ $t('AddSaleReturn.Cancel') }}
                                    </button>
                                </div>
                                <div v-else>
                                    <!--<button class="btn btn-primary  mr-2"
                                        v-on:click="saveSaleReturn('SaleReturn',false,false)"
                                        v-if="isValid('Can Save Sale Return') && isValid('Can Edit  Sale Return')"
                                        :disabled="$v.$invalid || sale.saleItems.filter(x => x.outOfStock).length > 0 || sale.saleItems.filter(x => x.quantity=='').length > 0 || sale.saleItems.filter(x => x.unitPrice=='').length > 0">
                                    <i class="far fa-save"></i>  {{ $t('PurchaseOrder.UpdateAsDraft') }}
                                </button>-->

                                    <button class="btn btn-primary  mr-2"
                                            v-on:click="saveSaleReturn('SaleReturn',true,false)"
                                            v-if="isValid('CanAddSaleReturn')"
                                            :disabled="$v.$invalid || sale.saleItems.filter(x => x.outOfStock).length > 0 || sale.saleItems.filter(x => x.totalPiece=='').length > 0 || sale.saleItems.filter(x => x.unitPrice=='').length > 0">
                                        <i class="far fa-save"></i> {{ $t('AddSaleReturn.UpdateAsPost') }}
                                    </button> <button class="btn btn-primary  mr-2"
                                                      v-on:click="saveSaleReturn('SaleReturn',true,true)"
                                                      v-if="isValid('CanAddSaleReturn') && isValid('CanPrintInvoice') "
                                                      :disabled="$v.$invalid || sale.saleItems.filter(x => x.outOfStock).length > 0 || sale.saleItems.filter(x => x.totalPiece=='').length > 0 || sale.saleItems.filter(x => x.unitPrice=='').length > 0">
                                        <i class="far fa-save"></i> {{ $t('AddSaleReturn.UpdateAsPostandPrint') }}
                                    </button>
                                    <button class="btn btn-danger  mr-2"
                                            v-on:click="goToSale">
                                        {{ $t('AddSaleReturn.Cancel') }}
                                    </button>
                                </div>
                            </div>

                            <div class="card-footer col-md-3" v-else>
                                <loading :name="loading" :active.sync="loading"
                                         :can-cancel="false"
                                         :is-full-page="true"></loading>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-sm-6 ml-auto mr-auto" v-else>
                <div class="card p-3 text-center " v-if="bankDetail">
                    <h4 class="">{{ $t('AddSaleReturn.FirstStartInvoice') }}</h4>
                    <router-link :to="{path: '/WholeSaleDay', query: { token_name:'DayStart_token', fromDashboard:'true' } }"><a href="javascript:void(0)" class="btn btn-outline-danger ">{{ $t('AddSaleReturn.DayStart') }}</a></router-link>
                </div>
                <div class="card p-3 text-center " v-else>
                    <h4 class="">{{ $t('AddSaleReturn.FirstStartInvoice') }}</h4>
                    <router-link :to="{path: '/dayStart', query: { token_name:'DayStart_token', fromDashboard:'true' } }"><a href="javascript:void(0)" class="btn btn-outline-danger ">{{ $t('AddSaleReturn.DayStart') }}</a></router-link>
                </div>
            </div>

            <bulk-attachment :attachmentList="sale.attachmentList" :show="show" v-if="show" @close="attachmentSave" />

            <saleReturnReport :printDetails="printDetails" :headerFooter="headerFooter" v-if="printDetails.length != 0 && printTemplate!='Template6' " :isTouchScreen="saleReturn" v-bind:key="printRender"></saleReturnReport>
            <SmartDigitalInvoice :printDetails="printDetails" :formName="'SaleReturn'" :isTouchScreen="saleReturn" :headerFooter="headerFooter" v-if="printDetails.length != 0  && printTemplate=='Template6' " v-bind:key="printRender" />

            <readymade-garments :printDetail="printDetailsPos" :saleReturnRegNo="saleReturnRegNo" :isDoublePrint="false" :isTouchScreen="saleReturn" :headerFooter="headerFooter" v-if="printDetailsPos.length != 0" v-bind:key="printRenderPos" />
        </div>

        
        <!---->
    </div>



    <div v-else> <acessdenied></acessdenied></div>
</template>
<script>
    import clickMixin from '@/Mixins/clickMixin'
    import Multiselect from "vue-multiselect";

    /* END EXTERNAL SOURCE */
    /* BEGIN EXTERNAL SOURCE */

    import moment from "moment";
    import Loading from 'vue-loading-overlay';
    import "vue-loading-overlay/dist/vue-loading.css";
    import { required, requiredIf } from "vuelidate/lib/validators";
    import { VueEditor } from "vue2-editor";
    //import VueBarcode from 'vue-barcode';
    export default {
        mixins: [clickMixin],
        name: "AddSaleReturn",
        components: {
            Loading,
            Multiselect,
            VueEditor
        },
        data: function () {
            return {
                bankDetail: false,
                saleReturnRegNo: '',
                printTemplate: '',
                saleReturn: 'saleServiceReturn',
                printDetails: [],
                printDetailsPos: [],
                printRender: 0,
                printRenderPos: 0,
                openBatch: 1,
                isFifo: false,
                headerFooter: {
                    footerEn: '',
                    footerAr: '',
                    company: ''
                },
                toggleValue: '',
                buttons: [
                    {
                        id: false,
                        icon: "money-bill-alt-regular.svg",
                        title: "Cash",
                    },
                    {
                        id: true,
                        icon: "credit-card-solid.svg",
                        title: "Credit",
                    },
                ],
                rendered: 0,
                sale: {
                    id: "00000000-0000-0000-0000-000000000000",
                    date: "",
                    taxMethod: "",
                    taxRateId: "",
                    saleInvoiceId: "",
                    registrationNo: "",
                    customerId: "00000000-0000-0000-0000-000000000000",
                    dueDate: "",
                    wareHouseId: "",
                    saleItems: [],
                    attachmentList: [],
                    isCredit: false,
                    cashCustomer: "",
                    mobile: "",
                    code: "",
                    invoiceType: "",
                    isSaleReturnPost: false,
                    isSerial: false,
                    dayStart: false,
                    isService: false
                },
                loading: false,
                summary: Object,
                autoNumber: '',
                language: 'Nothing',
                CompanyID: '',
                UserID: '',
                employeeId: '',
                isDayAlreadyStart: false,
                show: false,
                saleDefaultVat: '',
            };
        },
        validations: {
            sale: {
                date: { required },
                registrationNo: { required },
                customerId: {
                    required: requiredIf((x) => x.isCredit)
                },
                dueDate: {},
                wareHouseId: {},
                saleItems: {
                    required
                },
                cashCustomer: {
                    required: requiredIf((x) => !x.isCredit && (x.customerId == '00000000-0000-0000-0000-000000000000' || x.customerId == null))

                },
                mobile: {},
                code: {},
            }
        },

        methods: {
            Attachment: function () {
                this.show = true;
            },

            attachmentSave: function (attachment) {

                this.sale.attachmentList = attachment;
                this.show = false;
            },

            PrintInvoicePos: function (value) {
                var root = this;
                var token = '';
                root.saleReturnRegNo = value.invoiceNo;
                this.isDisabled = true;
                this.PrinterInterval();
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get("/Sale/SaleDetail?id=" + value.id, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                    .then(function (response) {
                        if (response.data != null) {
                            root.printDetailsPos = response.data;
                            root.printRenderPos++;
                            root.loading = false
                        }
                    });
            },

            PrinterInterval: function () {
                var root = this;

                this.printInterval = setInterval(() => {
                    root.isDisabled = false;
                }, 3000);
            },
            getBase64Image: function (path) {
                var root = this;
                var token = '';
                if (root.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                this.headerFooter.company.logoPath = 'data:image/png;base64,' + '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';

                root.$https
                    .get('/Contact/GetBaseImage?filePath=' + path, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {

                        if (response.data != null) {
                            root.filePath = response.data;
                            root.headerFooter.company.logoPath = 'data:image/png;base64,' + root.filePath;
                        }
                    });
            },
            GetInvoicePrintSetting: function () {
                var root = this;

                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('/Sale/printSettingDetail', { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null && response.data != '') {

                            root.headerFooter.footerEn = response.data.termsInEng;
                            root.headerFooter.footerAr = response.data.termsInAr;
                            root.headerFooter.isHeaderFooter = response.data.isHeaderFooter;
                            root.headerFooter.englishName = response.data.englishName;
                            root.headerFooter.arabicName = response.data.arabicName;
                            root.headerFooter.customerAddress = response.data.customerAddress;
                            root.headerFooter.customerVat = response.data.customerVat;
                            root.headerFooter.customerNumber = response.data.customerNumber;
                            root.headerFooter.cargoName = response.data.cargoName;
                            root.headerFooter.customerTelephone = response.data.customerTelephone;
                            root.headerFooter.itemPieceSize = response.data.itemPieceSize;
                            root.headerFooter.styleNo = response.data.styleNo;
                            root.headerFooter.blindPrint = response.data.blindPrint;
                            root.headerFooter.showBankAccount = response.data.showBankAccount;
                            root.headerFooter.bankAccount1 = response.data.bankAccount1;
                            root.headerFooter.bankAccount2 = response.data.bankAccount2;
                            root.headerFooter.bankIcon1 = response.data.bankIcon1;
                            root.headerFooter.bankIcon2 = response.data.bankIcon2;
                            root.headerFooter.customerNameEn = response.data.customerNameEn;
                            root.headerFooter.customerNameAr = response.data.customerNameAr;
                            root.headerFooter.exchangeDays = response.data.exchangeDays;
                            root.headerFooter.printOptions = response.data.printOptions;
                            root.headerFooter.invoicePrint = response.data.invoicePrint;
                            root.headerFooter.welcomeLineEn = response.data.welcomeLineEn;
                            root.headerFooter.welcomeLineAr = response.data.welcomeLineAr;
                            root.headerFooter.closingLineEn = response.data.closingLineEn;
                            root.headerFooter.closingLineAr = response.data.closingLineAr;
                            root.headerFooter.contactNo = response.data.contactNo;
                            root.headerFooter.managementNo = response.data.managementNo;

                            root.headerFooter.businessAddressArabic = response.data.businessAddressArabic;
                            root.headerFooter.businessAddressEnglish = response.data.businessAddressEnglish;
                            root.headerFooter.headerImage = response.data.headerImageForPrint;
                            root.headerFooter.footerImage = response.data.footerImageForPrint;
                        }

                    },
                        function (error) {
                            this.loading = false;
                            console.log(error);
                        });
            },
            
            GetHeaderDetail: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get("/Company/GetCompanyDetail?id=" + localStorage.getItem('CompanyID'), { headers: { Authorization: `Bearer ${token}` }, })
                    .then(function (response) {
                        if (response.data != null) {
                            root.headerFooter.company = response.data;
                            root.GetInvoicePrintSetting();
                            if (root.overWrite) {

                                root.headerFooter.company.nameArabic = root.businessNameArabic;
                                root.headerFooter.company.nameEnglish = root.businessNameEnglish;
                                root.headerFooter.company.categoryArabic = root.businessTypeArabic;
                                root.headerFooter.company.categoryEnglish = root.businessTypeEnglish;

                                root.headerFooter.company.companyNameArabic = root.companyNameArabic;
                                root.headerFooter.company.companyNameEnglish = root.companyNameEnglish;
                                root.headerFooter.company.logoPath = root.businessLogo;

                            }
                            root.getBase64Image(root.headerFooter.company.logoPath);
                        }
                    });
            },
            PrintInvoice: function (value) {

                
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.printDetails = [];

                debugger
                root.$https.get("/Sale/SaleDetail?id=" + value, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                    .then(function (response) {
                        if (response.data != null) {
                            root.saleReturnDesign = true;

                            root.printDetails = response.data;
                            if (localStorage.getItem('IsMultiUnit') == 'true' && localStorage.getItem('decimalQuantity') == 'true') {
                                root.printDetails.saleItems.forEach(function (x) {
                                    x.highQty = parseInt(parseFloat(x.quantity) / parseFloat(x.product.unitPerPack));
                                    x.newQuantity = parseFloat(parseFloat(x.quantity) % parseFloat(x.product.unitPerPack)).toFixed(3).slice(0, -1);
                                    x.unitPerPack = x.product.unitPerPack;
                                });
                            }
                            if (localStorage.getItem('IsMultiUnit') == 'true' && localStorage.getItem('decimalQuantity') != 'true') {
                                root.printDetails.saleItems.forEach(function (x) {
                                    x.highQty = parseInt(parseInt(x.quantity) / parseInt(x.product.unitPerPack));
                                    x.newQuantity = parseInt(parseInt(x.quantity) % parseInt(x.product.unitPerPack));
                                    x.unitPerPack = x.product.unitPerPack;
                                });
                            }
                            root.printRender++;
                            root.loading = false
                        }
                    });
            },
            languageChange: function (lan) {

                if (this.language == lan) {
                    if (this.sale.id == '00000000-0000-0000-0000-000000000000') {

                        var getLocale = this.$i18n.locale;
                        this.language = getLocale;

                        this.$router.go('/addSale');
                    }
                    else {
                        this.$swal({
                            title: 'Error!',
                            text: 'You cannot Change language during update, otherwise your current page data will be lose',
                            type: 'error',
                            confirmButtonClass: "btn btn-danger",
                            icon: 'error',
                            timer: 4000,
                            timerProgressBar: true,
                        });
                    }
                }


            },
            isCredit: function (credit) {
                this.sale.isCredit = credit.id;
                if (!this.sale.isCredit) {
                    this.sale.customerId = null;
                }

            },
            getSaleDetail: function (id) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                this.loading = true;
                root.$https.get('/Sale/SaleDetail?Id=' + id + '&isFifo=' + this.isFifo + '&openBatch=' + this.openBatch, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null) {

                            root.sale.isCredit = response.data.isCredit;
                            root.sale.taxRateId = response.data.taxRateId;
                            root.sale.taxMethod = response.data.taxMethod;
                            root.sale.invoiceType = response.data.invoiceType;
                            root.sale.cashCustomer = response.data.cashCustomer;
                            root.sale.cashCustomerId = response.data.cashCustomerId;
                            root.sale.date = moment().format("LLL");
                            root.sale.dueDate = moment().format("LLL");
                            root.sale.mobile = response.data.mobile;
                            root.sale.code = response.data.code;
                            root.sale.customerId = response.data.customerId;
                            root.sale.saleItems = response.data.saleItems;
                            root.sale.saleOrderId = response.data.saleOrderId;
                            root.sale.isService = response.data.isService;
                            root.sale.termAndCondition = response.data.termAndCondition;
                            root.sale.termAndConditionAr = response.data.termAndConditionAr;
                            root.sale.warrantyLogoPath = response.data.warrantyLogoPath;

                            if (localStorage.getItem('IsMultiUnit') == 'true' && localStorage.getItem('decimalQuantity') == 'true') {
                                root.sale.saleItems.forEach(function (x) {
                                    x.highQty = parseInt(parseFloat(x.remainingQuantity) / parseFloat(x.product.unitPerPack));
                                    x.quantity = parseFloat(parseFloat(x.remainingQuantity) % parseFloat(x.product.unitPerPack)).toFixed(3).slice(0, -1);
                                    x.unitPerPack = x.product.unitPerPack;
                                });
                            }
                            else if (localStorage.getItem('IsMultiUnit') == 'true' && localStorage.getItem('decimalQuantity') != 'true') {
                                root.sale.saleItems.forEach(function (x) {
                                    x.highQty = parseInt(parseInt(x.remainingQuantity) / parseInt(x.product.unitPerPack));
                                    x.quantity = parseInt(parseInt(x.remainingQuantity) % parseInt(x.product.unitPerPack));
                                    x.unitPerPack = x.product.unitPerPack;
                                });
                            }
                            else {
                                root.sale.saleItems.forEach(function (x) {
                                    x.highQty = 0;
                                    x.quantity = parseInt(x.remainingQuantity);
                                });
                            }
                            root.rendered++;
                            root.loading = false;

                        }
                    },
                        function (error) {
                            root.$swal.fire(
                                {
                                    icon: 'error',
                                    title: 'Something Went Wrong!',
                                    text: error,
                                });
                            root.loading = false;
                        });
            },

            updateSummary: function (summary) {
                this.summary = summary;
            },
            AutoIncrementCode: function () {
                var root = this;
                var token = "";
                if (root.$session.exists()) {
                    token = localStorage.getItem("token");
                }

                root.$https
                    .get("/Sale/SaleAutoGenerateNo?invoiceType=" + "SaleReturn", {
                        headers: { Authorization: `Bearer ${token}` },
                    })
                    .then(function (response) {
                        if (response.data != null) {
                            root.sale.registrationNo = response.data.saleReturn;
                        }
                    });
            },
            SaveSaleItems: function (saleItems) {
                this.sale.saleItems = saleItems;
            },
            saveSaleReturn: function (invoiceType, status, print) {
                this.loading = true;
                var root = this;
                root.sale.invoiceType = invoiceType;
                root.sale.isSaleReturnPost = status;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                if (!this.sale.isCredit) {
                    this.sale.dueDate = moment().format("DD MMM YYYY");
                }
                this.sale.saleItems.forEach(function (x) {
                    x.highUnitPrice ? x.quantity = (x.highQty * x.unitPerPack) + x.quantity : x.quantity = x.totalPiece;
                });

                this.sale.isSerial = localStorage.getItem('IsSerial') == 'true' ? true : false;
                this.sale.isFifo = this.isFifo;
                this.$https
                    .post('/Sale/SaveSaleReturn', root.sale, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(response => {
                        if (response.data.message.id != '00000000-0000-0000-0000-000000000000' && response.data.action == "Add") {
                            root.info = response.data.bpi

                            if (print) {
                                root.PrintInvoice(response.data.message.id);

                            }
                            else {
                                root.$swal({
                                    title: "Saved!",
                                    text: response.data.message.isAddUpdate,
                                    type: 'success',
                                    confirmButtonClass: "btn btn-success",
                                    buttonStyling: false,
                                    icon: 'success',
                                    timer: 1500,
                                    timerProgressBar: true,

                                }).then(function (ok) {
                                    if (ok != null) {
                                        if (root.isValid('CanViewSaleReturn')) {
                                            root.$router.push({
                                                path: '/ServiceSaleReturn',
                                                query: {
                                                    data: 'AddServiceSaleReturn'
                                                }
                                            });
                                        }
                                        else {
                                            root.$router.go();
                                        }

                                    }
                                });
                            }

                        }
                        else if (response.data.message.id != '00000000-0000-0000-0000-000000000000' && response.data.action == "Update") {
                            root.info = response.data.bpi

                            root.$swal({
                                title: "Saved!",
                                text: response.data.message.isAddUpdate,
                                type: 'success',
                                confirmButtonClass: "btn btn-success",
                                buttonStyling: false,
                                icon: 'success',
                                timer: 1500,
                                timerProgressBar: true,

                            }).then(function (ok) {
                                if (ok != null) {
                                    if (root.sale.invoiceType == 'Draft') {
                                        if (root.isValid('CanViewSaleReturn')) {
                                            root.$router.push({
                                                path: '/ServiceSaleReturn',
                                                query: {
                                                    data: 'AddServiceSaleReturn'
                                                }
                                            });
                                        }
                                        else {
                                            root.$router.go();
                                        }

                                    }
                                    else {
                                        if (root.isValid('CanViewSaleReturn')) {
                                            root.$router.push({
                                                path: '/ServiceSaleReturn',
                                                query: {
                                                    data: 'AddServiceSaleReturn'
                                                }
                                            });
                                        }
                                        else {
                                            root.$router.go();
                                        }

                                    }
                                }
                            });
                        }
                        else {
                            if (localStorage.getItem('IsMultiUnit') == 'true' && localStorage.getItem('decimalQuantity') == 'true') {
                                root.sale.saleItems.forEach(function (x) {
                                    x.highQty = parseInt(parseFloat(x.quantity) / parseFloat(x.unitPerPack));
                                    x.quantity = parseFloat(parseFloat(x.quantity) % parseFloat(x.unitPerPack)).toFixed(3).slice(0, -1);
                                });
                            }
                            if (localStorage.getItem('IsMultiUnit') == 'true' && localStorage.getItem('decimalQuantity') != 'true') {
                                root.sale.saleItems.forEach(function (x) {
                                    x.highQty = parseInt(parseInt(x.quantity) / parseInt(x.unitPerPack));
                                    x.quantity = parseInt(parseInt(x.quantity) % parseInt(x.unitPerPack));
                                });
                            }
                            root.$swal({
                                title: 'Error!',
                                text: response.data.message.isAddUpdate,
                                type: 'error',
                                confirmButtonClass: "btn btn-danger",
                                icon: 'error',
                                timer: 1500,
                                timerProgressBar: true,
                            });
                        }

                    })
                    .catch(error => {
                        if (localStorage.getItem('IsMultiUnit') == 'true' && localStorage.getItem('decimalQuantity') == 'true') {
                            root.sale.saleItems.forEach(function (x) {
                                x.highQty = parseInt(parseFloat(x.quantity) / parseFloat(x.unitPerPack));
                                x.quantity = parseFloat(parseFloat(x.quantity) % parseFloat(x.unitPerPack)).toFixed(3).slice(0, -1);
                            });
                        }
                        if (localStorage.getItem('IsMultiUnit') == 'true' && localStorage.getItem('decimalQuantity') != 'true') {
                            root.sale.saleItems.forEach(function (x) {
                                x.highQty = parseInt(parseInt(x.quantity) / parseInt(x.unitPerPack));
                                x.quantity = parseInt(parseInt(x.quantity) % parseInt(x.unitPerPack));
                            });
                        }
                        console.log(error)
                        root.$swal.fire(
                            {
                                icon: 'error',
                                title: 'Something Went Wrong!',
                                text: error,
                            });

                        root.loading = false
                    });

            },

            goToSale: function () {

                if (this.isValid('CanViewSaleReturn')) {
                    this.$router.push({
                        path: '/ServiceSaleReturn',
                        query: {
                            data: 'AddServiceSaleReturn'
                        }
                    });
                }
                else {
                    this.$router.go();
                }

            },

        },
        created: function () {
            this.GetHeaderDetail();
            this.$emit('input', this.$route.name);
            this.saleDefaultVat = localStorage.getItem('SaleDefaultVat');

            if (this.$route.query.data != undefined) {
                var data = this.$route.query.data;
                this.sale.id = data.id;
                this.sale.wareHouseId = data.wareHouseId;
                this.sale.invoiceType = data.invoiceType;
                this.sale.cashCustomer = data.cashCustomer;
                this.sale.date = moment(data.date).format("LLL");
                this.sale.dueDate = moment(data.dueDate).format("LLL");
                this.sale.registrationNo = data.registrationNo;
                this.sale.mobile = data.mobile;
                this.sale.code = data.code;
                this.sale.customerId = data.customerId;
                this.sale.isCredit = data.isCredit;
                this.sale.saleItems = data.saleItems;


                if (localStorage.getItem('IsMultiUnit') == 'true' && localStorage.getItem('decimalQuantity') == 'true') {
                    this.sale.saleItems.forEach(function (x) {
                        x.highQty = parseInt(parseFloat(x.remainingQuantity) / parseFloat(x.product.unitPerPack));
                        x.quantity = parseFloat(parseFloat(x.remainingQuantity) % parseFloat(x.product.unitPerPack)).toFixed(3).slice(0, -1);
                        x.unitPerPack = x.product.unitPerPack;
                    });
                }
                else if (localStorage.getItem('IsMultiUnit') == 'true' && localStorage.getItem('decimalQuantity') != 'true') {
                    this.sale.saleItems.forEach(function (x) {
                        x.highQty = parseInt(parseInt(x.remainingQuantity) / parseInt(x.product.unitPerPack));
                        x.quantity = parseInt(parseInt(x.remainingQuantity) % parseInt(x.product.unitPerPack));
                        x.unitPerPack = x.product.unitPerPack;
                    });
                }
                else {
                    this.sale.saleItems.forEach(function (x) {
                        x.highQty = 0;
                        x.quantity = parseInt(x.remainingQuantity);
                    });
                }
            }
            else {
                this.sale.wareHouseId = localStorage.getItem('WareHouseId');
                //this.sale.taxRateId = localStorage.getItem('TaxRateId');
                //this.sale.taxMethod = localStorage.getItem('taxMethod');
            }
        },

        mounted: function () {
            this.language = this.$i18n.locale;
            var IsDayStart = localStorage.getItem('DayStart');
            var IsExpenseDay = localStorage.getItem('IsExpenseDay');
            var IsDayStartOn = localStorage.getItem('IsDayStart');
            this.bankDetail = localStorage.getItem('BankDetail') == 'true' ? true : false;
            this.printTemplate = localStorage.getItem('PrintTemplate');
            this.isFifo = localStorage.getItem('fIFO') == 'true' ? true : false;
            var batch = localStorage.getItem('openBatch')
            if (batch != undefined && batch != null && batch != "") {
                this.openBatch = batch
            }
            else {
                this.openBatch = 1
            }
            if (IsDayStart != 'true') {
                this.isDayAlreadyStart = true;
                if (this.$route.query.data == undefined) {
                    this.AutoIncrementCode();
                    this.sale.date = moment().format("LLL");
                    this.sale.dueDate = moment().format("LLL");
                }
                this.sale.dayStart = false
            }
            else {
                this.sale.dayStart = true
                if (IsExpenseDay == 'true') {
                    this.isDayAlreadyStart = false;
                }
                else {
                    this.CompanyID = localStorage.getItem('CompanyID');
                    this.UserID = localStorage.getItem('UserID');
                    this.employeeId = localStorage.getItem('EmployeeId');
                    if (IsDayStartOn == 'true') {
                        var root = this;
                        this.isDayAlreadyStart = true;
                        if (root.$route.query.data == undefined) {
                            root.AutoIncrementCode();
                            root.sale.date = moment().format("LLL");
                            root.sale.dueDate = moment().format("LLL");
                        }
                    }
                    else {
                        this.isDayAlreadyStart = false;
                    }
                }

            }

        },
    };
</script>

<style scoped>
    .poHeading {
        font-size: 32px;
        font-style: normal;
        line-height: 37px;
        font-weight: 500;
        font-size: 24px;
        line-height: 26px;
        color: #3178F6;
        text-align: center
    }

    .dateHeading {
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0.01em;
        color: #3178F6;
    }

    .bottomBorder {
        padding-top: 24px !important;
        border-bottom: 1px solid #EFF4F7;
    }
</style>
